import axios from "axios";
import Response from "../models/response";
import router from "../router";
import { SearchVehiclesQueryContext } from "./dto/searchVehiclesQueryContext";
import store from "../store";
import Util from "./util";

axios.interceptors.response.use(
  (response: any) => {
    return Promise.resolve(response);
  },
  (error: any) => {
    if (error.response.status === 401) {
      store.dispatch("auth/logout");
      router.push({ name: "Login" });
    }

    return Promise.reject(error);
  }
);

export default {
  all(params: any): Promise<Response> {
    const url = Util.apiUrl("/v1/vehicles");

    return axios
      .get(url, { params: params, headers: Util.authHeaders() })
      .then((resp: any) => Util.handleResponse(resp))
      .catch((error: any) => Util.handleResponse(error));
  },

  getByVin(vin: string): Promise<Response> {
    const url = Util.apiUrl(`/v1/vehicles/vin/${vin}`);

    return axios
      .get(url, { headers: Util.authHeaders() })
      .then((resp: any) => Util.handleResponse(resp))
      .catch((error: any) => Util.handleResponse(error));
  },

  search(queryContext: SearchVehiclesQueryContext): Promise<Response> {
    const url = Util.apiUrl("/v1/vehicles/search");

    return axios
      .post(url, queryContext, { headers: Util.authHeaders() })
      .then((resp: any) => Util.handleResponse(resp))
      .catch((error: any) => Util.handleResponse(error));
  },
};
